import { useQuery } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"

export function useFindOperationsWithEmptyFields(
  ids: number[],
  key: string,
  customFieldDefinitionId?: number
) {
  return useQuery(
    ["operationsWithEmptyFields", ids, key, customFieldDefinitionId],
    async () => {
      const response = await httpClient.get(
        "/supplier-traceability/find-operations-with-empty-fields",
        {
          params: {
            ids: ids.join(","),
            key,
            customFieldDefinitionId,
          },
        }
      )
      return response.data
    },
    {
      enabled: false,
    }
  )
}
